//Importaciones que se requieran para el procesamiento
import Vue from "vue";
import VueRouter from "vue-router";
import Inicio from "../views/InicioView.vue";
import auth from "../services/auth";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login", //path de la ruta
    name: "login" /*nombre de la ruta, para uso dentro de la aplicación, 
                    no se usa como path sino como identificador*/,
    component: () => import("../views/LoginView.vue"), //Aquí se importa la vista que se va a renderizar en el path
    meta: {
      //Información adicional asociada a la vista
      requiresAuth: false //Por ejemplo aquí se le indica que necesita autenticación para acceder a ella
    },
    children: [
      /*Si la ruta contiene sub-rutas se adicionan en children 
                  La estructura de las subrutas es la misma que la de las rutas*/
      {
        path: "crear-contrasena/:id_cliente",
        name: "crear_contrasena",
        component: () => import("../components/login/RecuperarClave.vue")
      }
    ]
  },
  {
    path: "/inicio",
    name: "ingresa",
    component: Inicio,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/simulador-creditos/:preSelect?",
    name: "creditos",
    component: () => import("../views/SimuladorCreditoView.vue"),
    meta: {
      requiresAuth: true,
      requiresBit: ["b_mayor"]
    }
  },
  {
    path: "/pago-web",
    name: "pagoweb",
    component: () => import("../views/PagarProductosView.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/seguimiento-credito",
    name: "seguimiento",
    component: () => import("../views/SeguimientoCreditoView.vue"),
    meta: {
      requiresAuth: true,
      requiresBit: ["b_creditos_firmar"]
    }
  },
  {
    path: "/productos/:product",
    name: "productos",
    component: () => import("../views/ProductosView.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/beneficiarios-capital",
    name: "benCapital",
    component: () => import("../views/BeneficiariosCapitalView.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/cuenta/:ajuste",
    name: "cuenta",
    component: () => import("../views/CuentaView.vue"),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/fin-firma-ecert",
    name: "fin_firma_ecert",
    component: () => import("../views/FinFirmaEcertView.vue"),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/mantencion",
    name: "mantencion",
    component: () => import("../views/MantencionView.vue")
  },
  {
    path: "/",
    redirect: "/inicio"
  },
  {
    path: "*",
    redirect: "/inicio"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  //Lógica que se ejecuta antes de renderizar la ruta a la vista respectiva
  //Primero se debe validar si la ruta requiere autenticación
  if (to.name === "mantencion") {
    if (store.state.parametros.mantencion) next();
    else next("/");
    return;
  } else if (to.name !== "mantencion" && store.state.parametros.mantencion) {
    next("/mantencion");
    return;
  } else {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      //Si la ruta requiere autenticación se valida si el usuario está autenticado
      if (auth.isAuthenticated()) {
        store.dispatch("updateBits");
        //Si el usuario está autenticado se valida si el usuario debe cambiar su clave
        let cambio_clave = auth.getUserLogged().b_cambiar_clave;
        if (parseInt(cambio_clave)) {
          if (to.path === "/cuenta/cambiar-clave") next();
          else next("/cuenta/cambiar-clave");
          return;
        }
        //Si el usuario no debe cambiar su clave se realizan otras validaciones según la ruta a la que desee acceder y sus precondiciones
        else {
          if (to.matched.some((record) => record.meta.requiresBit)) {
            let requiredBits = to.meta.requiresBit;
            if (store.getters.validBits(requiredBits)) {
              next();
              return;
            } else {
              next("/inicio");
              return;
            }
          }
          //Si la ruta es de pago web se valida si se está accediendo directamente o es retorno de transbank para determinar que mostrar
          // if (to.name === "pagoweb") {
          //   if (to.query.token_ws) {
          //     localStorage.setItem("token_ws", to.query.token_ws);
          //     next({
          //       path: "/pago-web",
          //       replace: true
          //     });
          //     return;
          //   } else if (to.query.TBK_ID_SESION && to.query.TBK_ORDEN_COMPRA) {
          //     let cancel_pay = {
          //       TBK_ID_SESION: to.query.TBK_ID_SESION,
          //       TBK_ORDEN_COMPRA: to.query.TBK_ORDEN_COMPRA
          //     };
          //     if (to.query.TBK_TOKEN) cancel_pay.TBK_TOKEN = to.query.TBK_TOKEN;

          //     localStorage.setItem("cancel_pay", JSON.stringify(cancel_pay));
          //     next({
          //       path: "/pago-web",
          //       replace: true
          //     });
          //     return;
          //   }
          //   next();
          //   return;
          // }
          //Si la ruta no tiene que validar condiciones especiales se redirige a la ruta solicitada
          else {
            next();
            return;
          }
        }
      }
      //Si el usuario no está autenticado se redirige a la ruta de login
      else {
        next("/login");
      }
    }
    //Si la ruta no requiere autenticación se valida si el usuario está autenticado para redirigirlo a la ruta de inicio
    else {
      if (auth.isAuthenticated()) {
        next("/ingresa");
        return;
      } else {
        next();
      }
    }
  }
});

export default router;
